import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reports-payment',
  templateUrl: './reports-payment.component.html',
  styleUrl: './reports-payment.component.scss'
})
export class ReportsPaymentComponent {
    activeTab: string = 'tab1';

  constructor(
    private router: Router
  ){}

  ngOnInit(): void {
  }

  routeTo(route: string): void {
    //asignar ruta absoluta 
    this.router.navigate([`/expense-reports/${route}`]);
  }

    routingTo(route:string){
    this.router.navigate(['expense-reports/'+route]);
  }

    changeTab(tabId: string): void {
    this.activeTab = tabId;
  }

}
